module.exports = __webpack_public_path__ + "static/media/desktop.6902534.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Waving/desktop.mp4
// module id = Kmlj
// module chunks = 1